import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SecondaryButton from "./Buttons/SecondaryButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

const ModalWidget = ({ open, onClose, title, children, actionLabel, onAction }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box sx={style}>
        {title && (
          <Typography id="modal-title" variant="h6" sx={{color: '172B4D'}}>
            {title}
          </Typography>
        )}
        <Box sx={{ mt: 2 }}>{children}</Box>
        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <SecondaryButton variant="outlined" onClick={onClose}>
            Close
          </SecondaryButton>
          {actionLabel && (
            <SecondaryButton variant="contained" onClick={onAction}>
              {actionLabel}
            </SecondaryButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalWidget;
